export const MIN_DISPLAYED_TIME = 4
export const MIN_DISPLAYED_TIME_PER_HOUR_MODE = 0
export const DEFAULT_TIME = 6

export const ESTIMATED_MONTH_SIZE = 290
export const OVERSCAN_VIRTUALIZED_MONTHS = 3
